export default __webpack_public_path__ + "static/media/bot.0df4f946.jpg";